import script from "./NavFloating.vue?vue&type=script&setup=true&lang=js"
export * from "./NavFloating.vue?vue&type=script&setup=true&lang=js"

import "./NavFloating.vue?vue&type=style&index=0&id=73337659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73337659"]])

export default __exports__